import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './positive.module.scss';

const METADATA = Metadata.define({
  description: 'Secondary positive badge indicator.',
  name: 'Positive Secondary Badge',
});

export default class SpdsIndicatorBadgePositiveSecondary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  secondary = true;
  variantClass = 'spds-indicator-badge-positive';
  variantStyles = styles;
}

export const BADGE_POSITIVE_SECONDARY_METADATA = SpdsIndicatorBadgePositiveSecondary.metadata;
